// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3NBuP","topBottomGutter":"Layout_topBottomGutter__1ucTj"};